﻿import { FC } from "react";

interface DisplayCurrencyProps {
    currencyCode: string;
    value: number;
    minimumDP?: number;
    maximumDP?: number;
}

export const DisplayCurrency: FC<DisplayCurrencyProps> = (props) => {
    return (
        <span className={`currency ${props.value < 0 ? "negative" : "positive"}`} title={`${props.currencyCode}`}>
            {
                new Intl.NumberFormat(navigator.language, {
                    style: "currency",
                    currency: props.currencyCode,
                    minimumFractionDigits: props.minimumDP,
                    maximumFractionDigits: props.maximumDP,
                }).format(props.value)
            }
        </span>
    );
};